<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-4 d-flex">
          <card class="card-eprf">
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              JOB DETAILS
            </p>
            <div style="height: 520px; overflow: auto; overflow-x: hidden">
              <p class="new-title">Job Reference No.</p>
              <p class="subtitle">{{ jobno }}</p>

              <p class="new-title">Collection Date</p>
              <p class="subtitle">{{ collectiondate }}</p>

              <p class="new-title">Service Location</p>
              <p class="subtitle">{{ servicelocation }}</p>

              <p class="new-title">Service Location Collection</p>
              <p class="subtitle">{{ servicelocationcollection }}</p>

              <p class="new-title">Company Name</p>
              <p class="subtitle">{{ companyName }}</p>

              <p class="new-title">Company Address</p>
              <p class="subtitle">{{ companyAddress }}</p>

              <p class="new-title">Phone No. / Fax No.</p>
              <p class="subtitle">{{ phoneNoFaxNo }}</p>

              <p class="new-title">PIC Full Name</p>
              <p class="subtitle">{{ picFullName }}</p>

              <p class="new-title">PIC Phone No. / Fax No.</p>
              <p class="subtitle">{{ picPhoneNoFaxNo }}</p>

              <p class="new-title">PIC Email</p>
              <p class="subtitle">{{ picEmail }}</p>
            </div>
          </card>
        </div>
        <div class="col-lg-8 d-flex" v-if="generate == false">
          <card class="card-eprf">
            <div class="row">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  QUOTATION
                </p>
              </div>
              <div class="col-lg-3 text-right">
                <div class="row">
                  <div class="col-lg">Cancelled Ref No:</div>
                </div>

                <div class="row" v-if="positionid == 1 || positionid == 2">
                  <div class="col-lg">
                    <el-select
                      v-model="cancelledref"
                      @change="sendCancelledRef()"
                    >
                      <el-option
                        class="select-primary"
                        v-for="(item, index) in cancelledrefs"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="row" v-else>
                  <div class="col-lg" style="font-weight: bold">
                    {{ cancelledref }}
                  </div>
                </div>
              </div>
            </div>
            <div
              style="height: 520px; overflow: auto; overflow-x: hidden"
              v-if="(positionid == 1 || positionid == 2) && step == 2"
            >
              <div class="row">
                <div class="col-lg-4">
                  <p class="new-title">
                    Subject Line <span style="color: #EC1B23">*</span>
                  </p>
                  <input
                    type="text"
                    v-model="subjectline"
                    :class="{ 'custom-input': true }"
                  />
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-lg">
                  <el-table
                    :data="quotations"
                    :header-cell-style="{
                      background: '#358DCC',
                      border: 'transparent',
                      'font-size': '14px',
                      'font-weight': '400',
                      color: '#FFFFFF',
                    }"
                    :cell-style="{ fontColor: '#707070' }"
                    :row-style="tableRowClassName"
                    style="color: #707070"
                  >
                    <el-table-column label="No." width="50" align="center">
                      <div slot-scope="scope">
                        <p
                          style="color: #707070"
                          v-if="scope.row.description != 'GRAND TOTAL'"
                        >
                          {{ scope.$index + 1 }}
                        </p>
                      </div>
                    </el-table-column>

                    <el-table-column label="Description" prop="description">
                      <template slot-scope="scope">
                        <div class="row">
                          <div class="col-lg">
                            {{ scope.row.description }}
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg">
                            <p
                              style="color: #707070"
                              v-if="scope.row.description !== 'GRAND TOTAL'"
                            >
                              Transportation Rate:
                            </p>
                          </div>
                        </div>
                      </template>
                    </el-table-column>

                    <!-- <el-table-column label="Description" prop="description">
                      <div slot-scope="scope">
                        <div class="row">
                          <div class="col-lg">
                            {{ row.description }}
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg">
                            <p style="color: #707070" v-if="scope.row.description != 'GRAND TOTAL'">
                              Transportation Rate:</p>
                          </div>
                        </div>
                      </div>
                    </el-table-column> -->

                    <el-table-column label="Rate " prop="rate">
                      <div slot-scope="scope">
                        <div class="row">
                          <div
                            class="col-lg-4"
                            style="padding-top: 5px"
                            v-if="scope.row.description != 'GRAND TOTAL'"
                          >
                            RM <span style="color: #EC1B23">*</span>
                          </div>
                          <div class="col-lg">
                            <input
                              type="number"
                              min="0"
                              style="color: #707070"
                              v-if="scope.row.description != 'GRAND TOTAL'"
                              :class="{ 'custom-input': true }"
                              v-model="scope.row.rate"
                              @change="rateChange(scope.$index)"
                            />
                          </div>
                          <div class="col-lg-2"></div>
                        </div>
                        <div class="row">
                          <div
                            class="col-lg-4"
                            style="padding-top: 5px"
                            v-if="scope.row.description != 'GRAND TOTAL'"
                          >
                            RM <span style="color: #EC1B23">*</span>
                          </div>
                          <div class="col-lg">
                            <input
                              type="number"
                              min="0"
                              style="color: #707070"
                              v-if="scope.row.description != 'GRAND TOTAL'"
                              :class="{ 'custom-input': true }"
                              v-model="scope.row.transrate"
                              @change="rateChange(scope.$index)"
                            />
                          </div>
                          <div class="col-lg-2"></div>
                        </div>
                      </div>
                    </el-table-column>

                    <el-table-column label="Est. Amount " prop="estamount">
                      <div slot-scope="{ row }">
                        <div class="row">
                          <div class="col-lg">
                            {{ row.estamount }} {{ row.estunit }}
                          </div>
                        </div>
                      </div>
                    </el-table-column>

                    <el-table-column label="Amount " prop="amount">
                      <div slot-scope="{ row }">
                        <div class="row">
                          <div class="col-lg-3">RM</div>
                          <div class="col-lg">{{ row.amount }}</div>
                        </div>
                      </div>
                    </el-table-column>
                  </el-table>
                </div>
              </div>

              <!-- future days akan jadi dropdown -->
              <div class="row">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-lg">
                      <div class="row">
                        <div class="col-lg-4">
                          <p class="new-title">
                            Delivery Term <span style="color: #EC1B23">*</span>
                          </p>
                        </div>
                        <div class="col-lg-2 text-center">
                          <input
                            style="text-align: center"
                            type="number"
                            min="0"
                            v-model="deliveryterm"
                            :class="{ 'custom-input': true }"
                          />
                        </div>
                        <div
                          class="col-lg-3 text-left"
                          style="padding-bottom: 5px"
                        >
                          <el-select
                            class="select-info tab select-width"
                            placeholder="Select"
                            v-model="selects.day"
                            style="border-bottom: 1px solid lightgray"
                          >
                            <el-option
                              v-for="option in selects.days"
                              class="select-info"
                              :value="option.value"
                              :label="option.label"
                              :key="option.value"
                            ></el-option>
                          </el-select>
                          <!-- <p class="new-title">Days</p> -->
                        </div>
                      </div>
                    </div>

                    <div class="col-lg">
                      <div class="row">
                        <div class="col-lg-5">
                          <p class="new-title">
                            Payment Term <span style="color: #EC1B23">*</span>
                          </p>
                        </div>
                        <div class="col-lg-2 text-center">
                          <input
                            style="text-align: center"
                            type="number"
                            min="0"
                            v-model="paymentterm"
                            :class="{ 'custom-input': true }"
                          />
                        </div>
                        <div class="col-lg-3 text-left">
                          <p class="new-title">Days</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="row">
                        <div class="col-lg-4">
                          <p class="new-title">
                            Validity <span style="color: #EC1B23">*</span>
                          </p>
                        </div>
                        <div class="col-lg-2">
                          <input
                            style="text-align: center"
                            type="number"
                            min="0"
                            v-model="validity"
                            :class="{ 'custom-input': true }"
                          />
                        </div>
                        <div class="col-lg-4 text-left">
                          <p class="new-title">Days</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- future -->
              <!-- <div class="row">
                <div class="col-lg">
                  <p class="new-title">Internal Remarks</p>
                  <input type="text" v-model="remark1" :class="{ 'custom-input': true }" />
                </div>
              </div> -->
              <div class="row" v-if="positionid == 1 || positionid == 2">
                <div class="col-lg">
                  <p class="new-title">Internal Remarks</p>
                  <input
                    type="text"
                    v-model="internalremark"
                    :class="{ 'custom-input': true }"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-lg">
                  <p class="new-title">Remarks</p>
                  <input
                    type="text"
                    v-model="remark1"
                    :class="{ 'custom-input': true }"
                  />
                </div>
              </div>
            </div>
            <div
              style="height: 520px; overflow: auto; overflow-x: hidden"
              v-if="(positionid == 1 || positionid == 2) && step != 2"
            >
              <div class="row">
                <div class="col-lg-4">
                  <p class="new-title">Subject Line</p>
                  <p class="subtitle">{{ subjectline }}</p>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-lg">
                  <el-table
                    :data="quotations"
                    :header-cell-style="{
                      background: '#358DCC',
                      border: 'transparent',
                      'font-size': '14px',
                      'font-weight': '400',
                      color: '#FFFFFF',
                    }"
                    :cell-style="{ fontColor: '#707070' }"
                    :row-style="tableRowClassName"
                    style="color: #707070"
                  >
                    <el-table-column label="No." width="50" align="center">
                      <div slot-scope="scope">
                        <p
                          style="color: #707070"
                          v-if="scope.row.description != 'GRAND TOTAL'"
                        >
                          {{ scope.$index + 1 }}
                        </p>
                      </div>
                    </el-table-column>

                    <el-table-column label="Description" prop="description">
                      <div slot-scope="{ row }">
                        <div class="row">
                          <div class="col-lg">
                            {{ row.description }}
                          </div>
                        </div>

                        <div
                          class="row"
                          v-if="row.description != 'GRAND TOTAL'"
                        >
                          <div class="col-lg">Transportation Rate:</div>
                        </div>
                      </div>
                    </el-table-column>

                    <el-table-column label="Rate" prop="rate">
                      <div
                        slot-scope="{ row }"
                        v-if="row.description != 'GRAND TOTAL'"
                      >
                        <div class="row">
                          <div class="col-lg">RM {{ row.rate }}</div>
                        </div>
                        <div class="row">
                          <div class="col-lg">RM {{ row.transrate }}</div>
                        </div>
                      </div>
                    </el-table-column>

                    <el-table-column label="Est. Amount" prop="estamount">
                      <div
                        slot-scope="{ row }"
                        v-if="row.description != 'GRAND TOTAL'"
                      >
                        {{ row.estamount }} {{ row.estunit }}
                      </div>
                    </el-table-column>

                    <el-table-column label="Amount " prop="amount">
                      <div slot-scope="{ row }">
                        <div class="row">
                          <div class="col-lg">RM {{ row.amount }}</div>
                        </div>
                      </div>
                    </el-table-column>
                  </el-table>
                </div>
              </div>

              <div class="row">
                <div class="col-lg">
                  <p class="new-title">Delivery Term</p>
                  <p class="subtitle">
                    {{ deliveryterm }} {{ deliverytermunit }}
                  </p>
                </div>
                <div class="col-lg">
                  <p class="new-title">Payment Term</p>
                  <p class="subtitle">{{ paymentterm }} Days</p>
                </div>
                <!-- <p class="sub-title">{{ this.paymentterm2 }}</p> -->
                <div class="col-lg">
                  <p class="new-title">Validity</p>
                  <p class="subtitle">{{ validity }} Days</p>
                </div>
              </div>

              <!-- future
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg">
                  <p class="new-title">Internal Remarks</p>
                  <p class="sub-title">{{ this.remark1 }}</p>
                </div>
              </div>
            </div> -->
              <div class="row" v-if="roleid == 1">
                <div class="col-lg">
                  <p class="new-title">Internal Remarks</p>
                  <p class="subtitle">{{ internalremark }}</p>
                </div>
              </div>

              <div class="row">
                <div class="col-lg">
                  <p class="new-title">Remarks</p>
                  <p class="subtitle">{{ this.remark1 }}</p>
                </div>
              </div>
            </div>
            <div
              style="height: 520px; overflow: auto; overflow-x: hidden"
              v-if="positionid != 1 && positionid != 2"
            >
              <div class="row">
                <div class="col-lg-4">
                  <p class="new-title">Subject Line</p>
                  <p class="subtitle">{{ subjectline }}</p>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-lg">
                  <el-table
                    :data="quotations"
                    :header-cell-style="{
                      background: '#358DCC',
                      border: 'transparent',
                      'font-size': '14px',
                      'font-weight': '400',
                      color: '#FFFFFF',
                    }"
                    :cell-style="{ fontColor: '#707070' }"
                    :row-style="tableRowClassName"
                    style="color: #707070"
                  >
                    <el-table-column label="No." width="50" align="center">
                      <div slot-scope="scope">
                        <p
                          style="color: #707070"
                          v-if="scope.row.description != 'GRAND TOTAL'"
                        >
                          {{ scope.$index + 1 }}
                        </p>
                      </div>
                    </el-table-column>

                    <el-table-column label="Description" prop="description">
                      <div slot-scope="{ row }">
                        <div class="row">
                          <div class="col-lg">
                            {{ row.description }}
                          </div>
                        </div>
                        <div
                          class="row"
                          v-if="row.description != 'GRAND TOTAL'"
                        >
                          <div class="col-lg">Transportation Rate:</div>
                        </div>
                      </div>
                    </el-table-column>

                    <el-table-column label="Rate" prop="rate">
                      <div
                        slot-scope="{ row }"
                        v-if="row.description != 'GRAND TOTAL'"
                      >
                        <div class="row">
                          <div class="col-lg">RM {{ row.rate }}</div>
                        </div>
                        <div class="row">
                          <div class="col-lg">RM {{ row.transrate }}</div>
                        </div>
                      </div>
                    </el-table-column>

                    <el-table-column label="Est. Amount" prop="estamount">
                      <div
                        slot-scope="{ row }"
                        v-if="row.description != 'GRAND TOTAL'"
                      >
                        {{ row.estamount }} {{ row.estunit }}
                      </div>
                    </el-table-column>

                    <el-table-column label="Amount " prop="amount">
                      <div slot-scope="{ row }">
                        <div class="row">
                          <div class="col-lg">RM {{ row.amount }}</div>
                        </div>
                      </div>
                    </el-table-column>
                  </el-table>
                </div>
              </div>

              <div class="row">
                <div class="col-lg">
                  <p class="new-title">Delivery Term</p>
                  <p class="subtitle">
                    {{ deliveryterm }} {{ deliverytermunit }}
                  </p>
                </div>
                <div class="col-lg">
                  <p class="new-title">Payment Term</p>
                  <p class="subtitle">{{ paymentterm }} Days</p>
                </div>
                <!-- <p class="sub-title">{{ this.paymentterm2 }}</p> -->
                <div class="col-lg">
                  <p class="new-title">Validity</p>
                  <p class="subtitle">{{ validity }} Days</p>
                </div>
              </div>

              <!-- future
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg">
                  <p class="new-title">Internal Remarks</p>
                  <p class="sub-title">{{ this.remark1 }}</p>
                </div>
              </div>
            </div> -->
              <div class="row" v-if="roleid == 1">
                <div class="col-lg">
                  <p class="new-title">Internal Remarks</p>
                  <p class="subtitle">{{ internalremark }}</p>
                </div>
              </div>

              <div class="row">
                <div class="col-lg">
                  <p class="new-title">Remarks</p>
                  <p class="subtitle">{{ this.remark1 }}</p>
                </div>
              </div>
            </div>
          </card>
        </div>
        <!-- <div v-if="generate == true" class="col-lg-4 d-flex">
          <card class="card-eprf">
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              QUOTATION
            </p>
            <p v-if="positionid == 2" class="newtitle">Edit Quotation</p>
            <base-button
              v-if="positionid == 2"
              type="primary"
              v-on:click="getJobPage()"
              style="text-transform: capitalize"
              >Edit</base-button
            >

            <p style="margin-top: 50px" class="newtitle" v-if="positionid == 2">
              Choose File from Your Desktop
            </p>
            <p class="sub-titles" v-if="positionid == 2">
              Please upload any existing contract for recurring job request
            </p>

            <div class="fileinput" v-if="positionid == 2">
              <label
                for="file-upload"
                type="primary"
                class="btn"
                style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                "
              >
                Choose File
              </label>
              <div
                class="d-flex justify-content-center spinner"
                v-if="this.uploadload == true"
              >
                <circle-8></circle-8>
              </div>

              <input
                accept="application/pdf"
                id="file-upload"
                ref="file"
                type="file"
                name="..."
                class="valid"
                :multiple="true"
                aria-invalid="false"
                style="display: none"
                v-on:change="onFileChange"
              />
            </div>
            
            <div
              style="
                height: 120px;
                padding: 0px 20px 20px 0px;
                margin: 0px 30px 20px 0px;
              "
              class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto"
            >
              <div
                v-for="(file, index) in allfilename"
                :key="index"
                class="row"
              >
                <div class="col-lg-8">
                  <p style="padding-left: 15px; color: #A5A5A5" id="file-name">
                    {{ file.filename }}
                  </p>
                </div>
                <div class="col-lg-4" v-if="positionid == 2">
                  <p
                    style="font-size: 12px; color: lightgray"
                    @click="removeFile(file.fileid)"
                  >
                    Remove
                  </p>
                </div>
              </div>
            </div>

            <p style="margin-top: 50px" class="newtitle">
              View Your Generated Quotation
            </p>
            <base-button
              type="primary"
              v-on:click="createPDF()"
              style="text-transform: capitalize"
              >View</base-button
            >
          </card>
        </div> -->

        <!-- <div class="col-lg"></div>

        <div class="col-lg-3">
          <card
            style="
            box-shadow: none;
              color: #A5A5A5;
              padding: 0px 0px 30px 30px;
              height: 630px;
              background-color: white;
            "
          >
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              NPV2110280002
            </p>

            <p class="new-title">Customer</p>
            <p class="subtitle">
              Ombak Biru Holdings 202, Jalan Port Klang Pelabuhan, 42005
              Selangor, Malaysia
            </p>

            <p class="new-title">Due Date</p>
            <p class="subtitle">21 Nov 2022</p>

            <p class="new-title">Job Created Date</p>
            <p class="subtitle">15 Nov 2022</p>

            <p class="new-title">Person in Charge (PIC)</p>
            <p class="subtitle">Amirah binti Azman</p>

            <p class="new-title">PIC Tel. No.</p>
            <p class="subtitle">+60 19 562 7890</p>

            <p class="new-title">Ship Name</p>
            <p class="subtitle">Eagle 01</p>
          </card>
        </div> -->
        <!-- <div class="col-lg"></div> -->

        <!-- <div class="col-lg-4">
          <card
            style="
            box-shadow: none;
              padding: 0px 0px 30px 30px;
              height: 630px;
              background-color: white;
            "
          >
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              PERMIT TO WORK (PTW)
            </p>
            <p class="new-title">Waste Type</p>
            <p class="subtitle">Annex I - Oily bilge water</p>

            <p class="new-title">Waste Quantity</p>
            <p class="subtitle">300 MT</p>

            <p class="new-title">Max Dedicated Storage Capacity</p>
            <p class="subtitle">500 MT</p>

            <p class="new-title">Amount of Waste Retained Onboard</p>
            <p class="subtitle">50 MT</p>
          </card>
        </div>
        <div class="col-lg"></div>

        <div class="col-lg-4">
          <card
            style="
            box-shadow: none;
              padding: 0px 0px 30px 30px;
              height: 630px;
              background-color: white;
            "
          >
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              QUOTATION
            </p>
            <div
              style="margin-left: -30px"
              class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto"
            >
              <p class="new-title">Subject Line</p>
              <div style="padding-right: 30px">
                <input
                  type="text"
                  v-model="subjectline"
                  :class="{ 'custom-input': true }"
                />
              </div>
             

              <p class="new-title">Description</p>
              <div style="padding-right: 30px">
                <input
                  type="text"
                  v-model="description"
                  :class="{ 'custom-input': true }"
                />
              </div>
            

              <p class="new-title">Service Location</p>
              <p class="subtitle">Johor Port</p>

              <p class="new-title">Rate Term</p>
              <el-select
                class="select-info tab select-width"
                placeholder="Select"
                v-model="selects.rate"
                style="width: 300px; border-bottom: 1px solid lightgray"
                @change="getType()"
              >
                <el-option
                  v-for="option in selects.rates"
                  class="select-info"
                  :value="option.value"
                  :label="option.label"
                  :key="option.value"
                ></el-option>
              </el-select>

              <p class="new-title">Delivery Term</p>
              <div style="padding-right: 30px">
                <input
                  type="text"
                  v-model="deliveryterm"
                  :class="{ 'custom-input': true }"
                />
              </div>

              <p class="new-title">Payment Term</p>
              <div style="padding-right: 30px">
                <input
                  type="text"
                  v-model="paymentterm"
                  :class="{ 'custom-input': true }"
                />
              </div>

              <p class="new-title">Validity</p>
              <div style="margin-left: -15px" class="col-lg-12">
                <el-date-picker
                  v-model="selects.date"
                  @change="getData()"
                ></el-date-picker>
              </div>

              <p class="new-title">Admin PIC Contact (if different)</p>
              <el-select
                class="select-info tab select-width"
                placeholder="Select"
                v-model="selects.adminpic"
                style="width: 300px; border-bottom: 1px solid lightgray"
                @change="getType()"
              >
                <el-option
                  v-for="option in selects.adminpics"
                  class="select-info"
                  :value="option.value"
                  :label="option.label"
                  :key="option.value"
                ></el-option>
              </el-select>

              <p class="new-title">Admin PIC Tel. No.</p>
              <div style="padding-right: 30px">
                <input
                  type="text"
                  v-model="admintelno"
                  :class="{ 'custom-input': true }"
                />
              </div>
             
            </div>
          </card>
        </div> -->
      </div>
      <div class="row">
        <div class="col-lg text-right">
          <base-button
            v-if="generate == false"
            wide
            type="danger"
            @click.native="prevTab"
            class="btn-previous"
          >
            BACK
          </base-button>
          <!-- <base-button
            v-if="generate == true"
            wide
            type="danger"
            @click="back()"
            class="btn-previous"
          >
            BACK
          </base-button> -->
          <base-button
            v-if="
              (positionid == 1 || positionid == 2) &&
              generate == false &&
              step == 2
            "
            type="primary"
            wide
            @click="generateQuotation()"
            class="btn-next"
          >
            GENERATE
          </base-button>

          <!-- <base-button
            v-if="(positionid == 1 || positionid == 4) && generate == false"
            type="primary"
            wide
            @click="next()"
            class="btn-next"
          >
            NEXT
          </base-button> -->

          <base-button
            v-if="positionid == 4 && generate == false && step == 2"
            type="cancel"
            wide
            class="btn-next"
            @click="modals.disputereason = true"
          >
            DISPUTE
          </base-button>
          <base-button
            v-if="positionid == 4 && generate == false && step == 2"
            type="primary"
            wide
            class="btn-next"
            @click="approve()"
          >
            APPROVE
          </base-button>
          <base-button
            v-if="positionid == 4 && generate == false && step == 2"
            type="primary"
            wide
            class="btn-next"
            @click="approveConcession()"
          >
            APPROVE CONCESSION
          </base-button>
          <base-button
            v-if="generate == false && step != 2"
            type="primary"
            wide
            @click="nextTab"
            class="btn-next"
          >
            NEXT
          </base-button>
        </div>
      </div>
      <div
        v-if="
          (positionid == 1 || positionid == 2) && generate == false && step == 2
        "
        class="row"
      >
        <div class="col-lg text-right">
          <base-button
            class="btn-link"
            style="color: #052d72; cursor: pointer; text-decoration: underline"
            @click="saveDraft()"
          >
            Save Draft
          </base-button>
          <!-- <p
            style="color: #052d72; cursor: pointer; text-decoration: underline"
            @click="saveDraft()"
          >
            Save Draft
          </p> -->
        </div>
      </div>

      <modal :show.sync="modals.disputereason" class="modal-eprf" centered>
        <b-card
          class="card text-center"
          style="background-color: #f5f6fa; box-shadow: none"
          border-variant="primary"
          header="REASON FOR DISPUTE"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <template #header>
            <div class="row">
              <div class="col-lg text-left">
                <h4 class="mb-0">REASON FOR DISPUTE</h4>
              </div>
              <div class="col-lg-3 text-right" style="padding-bottom: 10px">
                <base-button class="btn-icon btn-cancel btn-round btn-sm">
                  <i
                    style="
                      transform: translate(-50%, -50%);
                      color: white;
                      font-weight: 900;
                      font-size: 12px;
                    "
                    class="tim-icons icon-simple-remove"
                    @click="modals.disputereason = false"
                  ></i>
                </base-button>
              </div>
            </div>
          </template>

          <div class="row">
            <div class="col-lg-12">
              <textarea
                type="textarea"
                placeholder="Reason for rejection..."
                v-model="reason"
                :class="{ textarea: true }"
              ></textarea>
            </div>
          </div>

          <div class="row">
            <div class="col-lg text-right">
              <base-button type="primary" v-on:click="dispute()"
                >Submit</base-button
              >
            </div>
          </div>
        </b-card>
      </modal>
      <modal :show.sync="modals.generate" class="modal-eprf" centered>
        <div class="row">
          <div class="col-lg text-center">
            <img src="@/assets/img/tick.png" width="300" />
            <br />
            <br />
            <br />
            <h1>QUOTATION SUBMITTED</h1>
            <p>
              Admin Management has been notified to review and approve the
              quotation
            </p>
          </div>
        </div>
      </modal>
      <modal :show.sync="modals.approve" class="modal-eprf" centered>
        <div class="row">
          <div class="col-lg text-center">
            <img src="@/assets/img/tick.png" width="300" />
            <br />
            <br />
            <br />
            <h1>QUOTATION SUBMITTED</h1>
            <p>
              Customer has been notified to review and approve the quotation
            </p>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Option, Select, DatePicker } from "element-ui";
import swal from "sweetalert2";
import { ImageUpload, Modal } from "src/components";
import { Circle8 } from "vue-loading-spinner";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "jspdf-autotable";
import { BCard } from "bootstrap-vue";

export default {
  props: ["parentData"],
  components: {
    BCard,
    ImageUpload,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    Circle8,
    Modal,
    html2canvas,
  },
  props: ["test1"],
  data() {
    return {
      step: "",
      cancelledref: "",
      cancelledrefs: [],
      paymentterm1: "",
      accessid: 0,
      reason: "",
      positionid: "",
      roleid: "",
      landvesselflag: "LAND",
      jobno: "",
      collectiondate: "",
      servicelocation: "",
      servicelocationcollection: "",
      arrivalETA: "18 Nov 2022",
      departureETD: "15 Nov 2022",
      previousPort: "None",
      nextPort: "None",
      lastPortAndDate: "None",
      companyName: "Ombak Biru Holdings",
      companyAddress: "Coplace 2, Switzeeerrrrrss",
      phoneNoFaxNo: "08-98989989",
      picFullName: "Wahab bin Wahab",
      picPhoneNoFaxNo: "012-3569488",
      picEmail: "wahab@sendirianberhad.com",
      shipName: "Tiger Wave",
      imoNo: "8804275",
      shipType: "Ikan bilis tanker",
      grossTonnage: "220000",
      deadweightTonnage: "10000",
      owneroperatorname: "Abu bin Seman",
      callSign: "Bilis dot com",
      flagState: "Malaysia",
      sustainableCertificates: "1 - ISO 14001.pdf",
      quoid: "",
      subjectline: "",
      quotations: [
        // {
        //   id: "1",
        //   description: "Annex l - Oily Bilge Waste",
        //   rate: "2.0",
        //   estamount: "10",
        //   amount: "20",
        // },
        // {
        //   id: "1",
        //   description: "Annex l - Oily Bilge Waste",
        //   rate: "2.0",
        //   estamount: "10",
        //   amount: "20",
        // },
        // {
        //   id: "1",
        //   description: "Annex l - Oily Bilge Waste",
        //   rate: "2.0",
        //   estamount: "10",
        //   amount: "20",
        // },
        // {
        //   id: "1",
        //   description: "Annex l - Oily Bilge Waste",
        //   rate: "2.0",
        //   estamount: "10",
        //   amount: "20",
        // },
        // {
        //   id: "1",
        //   description: "GRAND TOTAL",
        //   rate: "",
        //   estamount: "",
        //   amount: "80",
        // },
      ],
      deliveryterm: "",
      deliverytermunit: "",
      paymentterm: "",
      validity: "",
      remark1: "",
      internalremark: "",
      modals: {
        generate: false,
        approve: false,
        disputereason: false,
      },
      generate: false,
      selectedFileName: "",
      allfilename: [],
      docs: "",
      document: 0,

      documentID: [],

      uploadload: false,

      img: null,
      imgdescription: "",
      image: "",
      imagebase64: "",
      images: {
        regular: null,
      },

      description: "None",

      admintelno: "+60197897654",

      selects: {
        date: "",

        rate: "",
        rates: [
          { value: "m3", label: "M³" },
          { value: "kg", label: "Kg" },
          { value: "unit", label: "Unit" },
        ],

        adminpic: "",
        adminpics: [
          { value: "01", label: "Amirah binti Azman" },
          { value: "02", label: "Yahya Abd Rahman" },
          { value: "03", label: "Haziq Haikal bin Ayub" },
        ],
        day: "Day",
        days: [
          {
            label: "Days",
            value: "Days",
          },
          {
            label: "Working Days",
            value: "Working Days",
          },
        ],
      },
      pdftable: [],
      //pdf
      companynamepdf: "",
      refno: "",
      date: "",
      currentpage: "",
      totalpage: "",
      companyaddresspdf: "",
      companyphonenopdf: "",
      companyemailpdf: "",
      attention: "",
      subject: "",

      deliverypdf: "",
      paymentpdf: "",
      validitypdf: "",
      remarkspdf: "",

      pic1pdf: "",
      pic1nopdf: "",
      pic2pdf: "",
      pic2nopdf: "",
      total: 0,
    };
  },
  created() {
    // this.generate = sessionStorage.getItem("generate");
    this.jobno = this.$route.params.jobnum.split("_")[0];
    this.getDetail();
    this.getCancelRef(this.jobno);
    this.positionid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );

    this.roleid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1])).role_id
    );
    console.log("position ID: ", this.positionid);

    window.addEventListener("beforeunload", function (event) {
      this.saveDraft();
      event.preventDefault();
    });
  },
  mounted() {},
  computed: {},
  watch: {
    quotations: {
      handler(newVal, oldVal) {
        let grandTotal = 0.0;
        const formatter = new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        newVal.map((item) => {
          if (item.description === "GRAND TOTAL") {
            item.amount = formatter.format(grandTotal);
          } else {

            if(item.rate == ""){
              item.rate = 0
            }

            if(item.transrate == ""){
              item.transrate = 0
            }

            item.amount = formatter.format(
              parseInt(item.estamount) * parseInt(item.rate) +
              parseInt(item.transrate)
            );

            grandTotal += 
              parseInt(item.estamount) * parseInt(item.rate) +
              parseInt(item.transrate)
          
          }
        });
      },
      deep: true,
    },
    generate() {
      console.log(this.generate);
    },
  },
  methods: {
    sendCancelledRef() {
      let obj = {
        reference_number: this.cancelledref,
      };

      this.$http
        .post(":10001/api/v1/incoming/" + this.jobno + "/accept", obj)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal = true;
          }
        });
    },
    getCancelRef(refno) {
      console.log(refno);

      this.$http
        .get(":10001/api/v1/incoming/" + refno + "/cancelled-ref")
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            for (var i = 0; i < response.reference_number.length; i++) {
              let obj = {
                value: response.reference_number[i],
                label: response.reference_number[i],
              };
              this.cancelledrefs.push(obj);
            }
          }
        });
    },
    dispute() {
      if (this.reason != "") {
        let obj = {
          quotation_dispute_reason: this.reason,
        };

        this.$http
          .put(
            ":10001/api/v1/incoming/" + this.jobno + "/quotation/reject",
            obj
          )
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              // swal({
              //   title: `Success!`,
              //   text: response,
              //   buttonsStyling: false,
              //   confirmButtonClass: "btn btn-primary btn-fill",
              //   type: "success",
              // });

              this.modals.disputereason = false;
              this.$router.push("/Incoming");
            }
          });
      } else {
        // reason is compulsory
        swal({
          title: `Info!`,
          text: "Please fill in the reason",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-primary btn-fill",
          type: "warning",
        });
      }
    },
    approveConcession() {
      swal({
        title: "Approve concession?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .put(
              ":10001/api/v1/incoming/scrap/" +
                this.jobno +
                "/quotation/concession/approve"
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                swal({
                  title: `Success!`,
                  text: "Approve success.",
                  buttonsStyling: false,
                  confirmButtonClass: "btn btn-primary btn-fill",
                  type: "success",
                }).then((result) => {
                  console.log(result);
                  if (result.value) {
                    //pastu kena ke mana
                    this.$router.push("/Incoming");
                  }
                });
              }
            })
            .catch((err) => {
              swal({
                title: `Error!`,
                text: "Approve failed.",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-cancel btn-fill",
                type: "error",
              });
            });
        }
      });
    },
    approve() {
      this.$http
        .put(":10001/api/v1/incoming/" + this.jobno + "/quotation/approve")
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.modals.approve = true;

            setTimeout(() => {
              this.modals.approve = false;
              this.$router.push("/Incoming");
            }, 1000);
          }
        });
    },
    next() {
      this.generate = true;
      this.positionid = parseInt(
        JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
          .position_id
      );
    },
    back() {
      this.positionid = parseInt(
        JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
          .position_id
      );
      this.generate = false;
    },
    createPDF() {
      let doc = jsPDF({
        orientation: "potrait",
      });

      const logo = new Image();
      logo.src = require("@/assets/img/afes.png");
      logo.onload = () => {
        this.options = Object.assign({}, this.options, {
          logo: {
            logo,
          },
        });
      };

      const data = this.pdftable;

      const columns = [
        "No.",
        "Description",
        "Rate (RM/KG)",
        "Est. Amount (KG)",
        "Amount (KG)",
      ];

      const rows = data.map((obj) => [
        obj.no,
        obj.desc,
        obj.rate,
        obj.estamt,
        obj.amt,
      ]);

      doc.addImage(
        logo,
        "PNG",
        doc.internal.pageSize.getWidth() - 50,
        10,
        40,
        40
      );

      doc.setFontSize(12);
      doc.text("QUOTATION", 25, 40);

      doc.setLineWidth(0.3);
      doc.line(10, 50, doc.internal.pageSize.getWidth() - 10, 50);

      doc.text(this.companynamepdf, 15, 55);

      var companyAddress = this.companyaddresspdf;
      var maxCharactersPerLine = 25;

      function splitTextIntoLines(text, maxLength) {
        var lines = [];
        while (text.length > maxLength) {
          var line = text.substring(0, maxLength);
          var lastSpace = line.lastIndexOf(" ");
          if (lastSpace !== -1) {
            lines.push(line.substring(0, lastSpace));
            text = text.substring(lastSpace + 1);
          } else {
            lines.push(line);
            text = text.substring(maxLength);
          }
        }
        lines.push(text);
        return lines;
      }

      var addressLines = splitTextIntoLines(
        companyAddress,
        maxCharactersPerLine
      );

      for (var i = 0; i < addressLines.length; i++) {
        var yPos = 60 + i * 5;
        doc.text(addressLines[i], 15, yPos);
      }

      doc.text("Ref No.", 130, 55);
      doc.text("Date", 130, 60);

      doc.text(":", 150, 55);
      doc.text(":", 150, 60);

      doc.text(this.refno, 152, 55);
      doc.text(this.date, 152, 60);

      doc.text("Tel :", 15, 80);
      doc.text(this.companyphoneno, 25, 80);

      doc.text("Email : -", 70, 80);
      // doc.text(this.companyemailpdf, 85, 80);

      doc.text("Attention", 15, 90);
      doc.text("Subject", 15, 95);

      doc.text(":", 35, 90);
      doc.text(":", 35, 95);

      doc.text(this.companyname, 40, 90);
      doc.text(this.title, 40, 95);

      doc.text("Dear Sir/Madam,", 15, 105);
      doc.text(
        "We appreciate this opportunity to offer you our quotation as follows:",
        15,
        115
      );

      const table = doc.autoTable({
        head: [columns],
        body: rows,
        startY: 120,
      });

      let deliveryTermsTextPositionY = table.autoTable.previous.finalY + 10;

      if (deliveryTermsTextPositionY > doc.internal.pageSize.getHeight() - 20) {
        doc.addPage();
        deliveryTermsTextPositionY = 20;
      }

      let nextContentYPosition = deliveryTermsTextPositionY + 10;

      if (nextContentYPosition > doc.internal.pageSize.getHeight() - 20) {
        doc.addPage();
        nextContentYPosition = 20;
      }

      doc.text("Delivery Terms", 15, table.autoTable.previous.finalY + 10);
      doc.text("Terms of Payment", 15, table.autoTable.previous.finalY + 15);
      doc.text("Validity", 15, table.autoTable.previous.finalY + 20);
      doc.text("Remarks", 15, table.autoTable.previous.finalY + 25);

      doc.text(":", 55, table.autoTable.previous.finalY + 10);
      doc.text(":", 55, table.autoTable.previous.finalY + 15);
      doc.text(":", 55, table.autoTable.previous.finalY + 20);
      doc.text(":", 55, table.autoTable.previous.finalY + 25);

      doc.text(
        this.deliveryterm + " Days",
        60,
        table.autoTable.previous.finalY + 10
      );
      doc.text(
        this.paymentterm1 + " Days",
        60,
        table.autoTable.previous.finalY + 15
      );
      doc.text(
        this.validity + " Days",
        60,
        table.autoTable.previous.finalY + 20
      );
      var text = this.remark1;
      var x = 60;
      var y = table.autoTable.previous.finalY + 25;

      var lines = doc.splitTextToSize(
        text,
        doc.internal.pageSize.width - x * 2
      );

      for (var i = 0; i < lines.length; i++) {
        if (y + 10 > doc.internal.pageSize.height) {
          doc.addPage();
          y = 25;
        }
        doc.text(lines[i], x, y);
        y += 5;
      }

      var finalYOfText = y;

      doc.text(
        "If you agree with the quotation, please fill in the Acknowledgement from as attached as soon as",
        15,
        finalYOfText + 20
      );

      doc.text("possible for further arrangement.", 15, finalYOfText + 25);
      doc.text(
        "Should you need any clarification, please contact:",
        15,
        finalYOfText + 30
      );
      doc.text(this.picname, 15, finalYOfText + 35);

      doc.text("at", 95, finalYOfText + 35);

      doc.text(this.picphoneno, 105, finalYOfText + 35);

      doc.text(
        "for ALAM FLORA ENVIRONMENTAL SOLUTIONS SDN BHD",
        15,
        finalYOfText + 55
      );
      doc.text(
        "Previously known as DRB-HICOM ENVIRONMENTAL SERVICES SDN BHD",
        15,
        finalYOfText + 60
      );
      // doc.text("Created by " + this.pic1pdf, 15, finalYOfText + 80);

      doc.save("WCO Quotation.pdf");

      console.log("pdf created");
    },
    getPDF() {
      this.pdftable = [];
      // pdftable: [{ no: 0, desc: "", rate: "", estamt: "", amt: "" }],

      this.$http
        .get(":10001/api/v1/incoming/" + this.jobno + "/quotation/generate")
        .then((res) => {
          if (!res.error) {
            let response = res.message;

            console.log("hui", response);

            this.companynamepdf = response.company_name;
            this.refno = response.reference_number;
            this.date = moment(response.quotation_issued_at).format(
              "DD-MM-YYYY"
            );
            // currentpage: "",
            // totalpage: "",
            this.companyaddresspdf = response.company_address;
            this.companyphonenopdf = response.customer_phone_number;
            this.companyemailpdf = response.customer_email;
            this.attention = response.customer_name;
            this.subject = response.subject_line;

            this.deliverypdf = response.delivery_term;
            this.paymentpdf = response.payment_term;
            this.validitypdf = response.validy;
            this.remarkspdf = response.remarks;

            this.pic1pdf = response.afes_pic_name;
            this.pic1nopdf = response.afes_pic_phone_number;
            this.pic2pdf = "";
            this.pic2nopdf = "";

            let ratee;
            let estamtt;
            let amt;
            let amountt = 0;
            for (var i = 0; i < response.waste_detail.length; i++) {
              ratee = response.waste_detail[i].rate;
              estamtt = response.waste_detail[i].estimated_quantity;
              amt = ratee * estamtt;
              let obj = {
                no: i + 1,
                desc:
                  response.waste_detail[i].waste_type_name +
                  "\n" +
                  response.waste_detail[i].waste_sub_type_name +
                  "\n" +
                  "Transportation rate: RM" +
                  response.waste_detail[i].transport_rate,
                rate: ratee,
                estamt: estamtt,
                amt: amt,
              };
              amountt += amt;
              this.pdftable.push(obj);
            }

            let obj2 = {
              no: "",
              desc: "GRAND TOTAL",
              rate: "",
              estamt: "",
              amt: amountt,
            };
            this.pdftable.push(obj2);
          }
        });
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },

    rateChange(index) {
      let formatter = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      // this.quotations[this.quotations.length - 1].amount = 0;

      //  calculate changes
      // this.quotations[index].amount =
      //   this.quotations[index].rate *
      //   parseInt(this.quotations[index].estamount);

      // this.quotations[index].amount = this.quotations[index].amount.toFixed(2);

      // var parts = this.quotations[index].amount.toString().split(".");
      // this.quotations[index].amount =
      //   parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
      //   (parts[1] ? "." + parts[1] : "");

      // for (var i = 0; i < this.quotations.length - 1; i++) {
      //   // Loop until second-to-last item
      //   this.quotations[this.quotations.length - 1].amount +=
      //     this.quotations[i].rate * parseInt(this.quotations[i].estamount);

      //   this.quotations[this.quotations.length - 1].amount += parseFloat(
      //     this.quotations[i].transrate
      //   );
      // }

      this.quotations[this.quotations.length - 1].amount = formatter.format(
        this.quotations[this.quotations.length - 1].amount
      );

      // var partss = this.quotations[this.quotations.length - 1].amount
      //   .toString()
      //   .split(".");
      // this.quotations[this.quotations.length - 1].amount =
      //   partss[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
      //   (partss[1] ? "." + partss[1] : "");
    },

    getDetail() {
      this.total = 0;
      this.allfilename = [];
      this.quotations = [];
      this.$http
        .get(":10001/api/v1/incoming/scrap/" + this.jobno)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            if (typeof response.dashboard_step == "string") {
              this.step = Number(response.dashboard_step);
            } else if (typeof response.dashboard_step == "number") {
              this.step = response.dashboard_step;
            } else {
              this.step = response.dashboard_step;
            }

            console.log("step", this.step);

            if (this.positionid == 1 || this.positionid == 2) {
              this.cancelledref = response.cancel_reference_no;
            } else {
              this.cancelledref =
                response.cancel_reference_no == ""
                  ? "N/A"
                  : response.cancel_reference_no;
            }

            this.collectiondate = moment(response.collection_date).format(
              "YYYY-MM-DD"
            );
            this.servicelocation = response.service_location.service_location;
            this.servicelocationcollection =
              response.service_location.collection_location;
            this.companyName = response.company.company_name;
            this.companyAddress = response.company.company_address;

            this.phoneNoFaxNo =
              (response.company.company_phone_number == "" ||
              response.company.company_phone_number == null
                ? "N/A"
                : response.company.company_phone_number) +
              " / " +
              (response.company.company_fax_number == "" ||
              response.company.company_fax_number == null
                ? "N/A"
                : response.company.company_fax_number);
            this.picFullName = response.pic.pic_name;
            this.picPhoneNoFaxNo =
              (response.pic.pic_phone_number == "" ||
              response.pic.pic_phone_number == null
                ? "N/A"
                : response.pic.pic_phone_number) +
              " / " +
              (response.pic.pic_fax_number == "" ||
              response.pic.pic_fax_number == null
                ? "N/A"
                : response.pic.pic_fax_number);

            this.picEmail = response.pic.pic_email;

            if (response.quotation != null) {
              this.quoid = response.quotation.quotation_id;
              this.subjectline = response.quotation.subject_line;
              this.deliveryterm = response.quotation.delivery_term;
              this.deliverytermunit = response.quotation.delivery_term_unit;
              this.paymentterm = response.quotation.payment_term;
              this.validity = response.quotation.validity;
              this.remark1 =
                response.quotation.remark == ""
                  ? "-"
                  : response.quotation.remark;
              this.internalremark =
                response.quotation.internal_remarks == ""
                  ? "-"
                  : response.quotation.internal_remarks;
            }

            let formatter = new Intl.NumberFormat("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });

            // waste detail
            for (var i = 0; i < response.waste_details.length; i++) {
              let amount =
                response.waste_details[i].rate *
                response.waste_details[i].estimated_quantity;

              var amount1 = amount.toFixed(2);

              var parts = amount1.toString().split(".");
              var amount3 =
                parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
                (parts[1] ? "." + parts[1] : "");

              let obj = {
                id: response.waste_details[i].waste_detail_id,
                description: response.waste_details[i].waste_type_name,
                transportationdesc: "-",
                rate: response.waste_details[i].rate.toFixed(2),
                transrate: response.waste_details[i].transport_rate,
                estamount: response.waste_details[i].estimated_quantity,
                estunit: response.waste_details[i].estimated_quantity_unit,
                amount: amount3,
                transportationrate: response.waste_details[i].transport_rate,
              };
              this.quotations.push(obj);
              this.total += amount;
              this.total += response.waste_details[i].transport_rate;
            }

            // this.total = this.total.toFixed(2);
            // var partss = this.total.toString().split(".");
            // this.total =
            //   partss[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
            //   (partss[1] ? "." + parts[1] : "");

            let ground = {
              id: "",
              description: "GRAND TOTAL",
              rate: "",
              estamount: "",
              amount: formatter.format(this.total),
            };
            this.quotations.push(ground);

            // files
            // if (response.quotation.quotation_support_document != null) {
            //   for (
            //     var i = 0;
            //     i < response.quotation.quotation_support_document.length;
            //     i++
            //   ) {
            //     let obj = {
            //       filename:
            //         response.quotation.quotation_support_document[i].filename,
            //       fileid:
            //         response.quotation.quotation_support_document[i]
            //           .quotation_support_document_id,
            //     };
            //     this.allfilename.push(obj);
            //   }
            // }
          }
        });
    },
    saveDraft() {
      // arrange waste details array
      let wastedetails = [];
      for (var i = 0; i < this.quotations.length; i++) {
        // console.log()
        if (this.quotations[i].description != "GRAND TOTAL") {
          let wasteObj = {
            waste_detail_id: this.quotations[i].id,
            rate: parseFloat(this.quotations[i].rate),
            transport_rate: parseFloat(this.quotations[i].transrate),
          };
          wastedetails.push(wasteObj);
        }
      }
      let obj = {
        reference_number: this.jobno,
        quotation: {
          quotation_id: 0,
          subject_line: this.subjectline,
          delivery_term: this.deliveryterm,
          delivery_term_unit: this.selects.day,
          payment_term: this.paymentterm,
          validity: this.validity,
          rate_term: "KG",
          remark: this.remark1,
          internal_remarks: this.internalremark,
        },
        waste_detail: wastedetails,
      };

      console.log("quo obj", obj);

      this.$http
        .put(":10001/api/v1/incoming/scrap/" + this.jobno + "/quotation", obj)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            //sini fix
            swal({
              title: `Success!`,
              text: `Quotation draft saved!`,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary btn-fill",
              type: "success",
            }).then((result) => {
              console.log(result);
              if (result.value == true) {
                this.$router.push("/Incoming");
              }
            });
            this.getDetail();
          }
        });
    },
    generateQuotation() {
      let wastedetails = [];

      if (
        this.subjectline != "" &&
        this.deliveryterm != "" &&
        this.paymentterm != "" &&
        this.validity != ""
      ) {
        // arrange waste details array
        for (var i = 0; i < this.quotations.length; i++) {
          // console.log()
          if (this.quotations[i].description != "GRAND TOTAL") {
            let wasteObj = {
              waste_detail_id: this.quotations[i].id,
              rate: parseFloat(this.quotations[i].rate),
              transport_rate: parseFloat(this.quotations[i].transrate),
            };
            wastedetails.push(wasteObj);
          }
        }
        let obj = {
          reference_number: this.jobno,
          quotation: {
            quotation_id: 0,
            subject_line: this.subjectline,
            delivery_term: this.deliveryterm,
            delivery_term_unit: this.selects.day,
            payment_term: this.paymentterm,
            validity: this.validity,
            rate_term: "KG",
            remark: this.remark1,
            internal_remarks: this.internalremark,
          },
          waste_detail: wastedetails,
        };

        this.$http
          .post(
            ":10001/api/v1/incoming/scrap/" + this.jobno + "/quotation",
            obj
          )
          .then((res) => {
            if (!res.error) {
              let response = res.message;

              this.modals.generate = true;
              setTimeout(() => {
                this.modals.generate = false;
                this.$router.push("/Incoming");
              }, 1500);
              this.getDetail();
              // this.nextTab();
              this.getPDF();

              // this.generate = true;
            }
          });
      } else {
        if (this.subjectline == "") {
          swal({
            title: `Info!`,
            text: "Subject line is required!",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-primary btn-fill",
            type: "warning",
          });
        }

        if (this.deliveryterm == "") {
          swal({
            title: `Info!`,
            text: "Delivery term is required!",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-primary btn-fill",
            type: "warning",
          });
        }

        if (this.paymentterm == "") {
          swal({
            title: `Info!`,
            text: "Payment term is required!",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-primary btn-fill",
            type: "warning",
          });
        }

        if (this.validity == "") {
          swal({
            title: `Info!`,
            text: "Validity is required!",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-primary btn-fill",
            type: "warning",
          });
        }
      }
    },
    nextTab() {
      let parameter = {
        step: "2",
        direction: "depan",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    prevTab() {
      let parameter = {
        step: "2",
        direction: "blkg",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        let style = { background: "#FFFFFF", color: "#15cf79" };
        return style;
      } else {
        let style = { background: "#f5f6fa", color: "#959595" };
        return style;
      }
    },
    onFileChange(event) {
      // swal({
      //   title: "Are you sure?",
      //   text: `You won't be able to revert this!`,
      //   type: "warning",
      //   showCancelButton: true,
      //   confirmButtonClass: "btn btn-primary btn-fill",
      //   cancelButtonClass: "btn btn-cancel btn-fill",
      //   confirmButtonText: "Continue",
      //   buttonsStyling: false,
      // }).then((result) => {
      if (result.value == true) {
        this.docs = this.$refs.file.files[0];
        const formData = new FormData();
        formData.append("document", this.docs);

        // to verify form data
        for (var pair of formData.entries()) {
          console.log(pair);
        }

        this.$http
          .post(
            ":10001/api/v1/incoming/" +
              this.jobno +
              "/quotation/quotation-document",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + sessionStorage.getItem("token"),
              },
            }
          )
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              console.log(response);
              swal({
                title: `Success!`,
                text: response,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-primary btn-fill",
                type: "success",
              });
              this.getDetail();
              this.uploadload = false;
            }
          });
      }
      // });
    },
    removeFile(fileid) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this action!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/incoming/" + this.jobno + "/quotation/" + fileid
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                swal({
                  title: `Success!`,
                  text: response,
                  buttonsStyling: false,
                  confirmButtonClass: "btn btn-primary btn-fill",
                  type: "success",
                });
                this.getDetail();
                this.generate = true;
              }
            });
        }
      });
    },
    getJobPage() {
      this.generate = false;
    },

    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$root.$emit("image", this.imagebase64);
        return res;
      });
    },
  },
};
</script>
<style scoped>
textarea {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 1px solid #2b3553;
  border-radius: 4px;
  background-color: transparent;
  font-size: 14px;
  resize: none;
  /* color: #1d253b; */
}

textarea:focus {
  outline: none !important;
  border: 1px solid #1d8cf8;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
}

.address {
  width: 100%;
  height: 100px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}

.huraian {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}

.new-title {
  margin-top: 20px;
  color: #A5A5A5;
}

.subtitle {
  color: #A5A5A5;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.sub-title {
  text-decoration: underline;
  color: #A5A5A5;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.scrollable {
  height: 500px;
  overflow-y: scroll;
  padding: 0px 0px 0px 30px;
  color: #A5A5A5;
}

.newtitle {
  color: #707070;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.sub-titles {
  margin-top: -5px;
  color: #A5A5A5;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #dce9ff;
  border-radius: 15px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #5e99ff;
  border-radius: 15px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #176bfd;
}
</style>
